<template>
  <div class="login-page">
    <div class="login-gradient-bg"></div>
    
    <div class="login-container">
      <!-- Chap tomondagi brend paneli -->
      <div class="brand-panel">
        <div class="brand-content">
          <div class="brand-header">
            <div class="logo-container">
              <div class="logo-glow"></div>
              <div class="logo-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <h1 class="brand-title">AvtoTesting</h1>
          </div>
          
          <p class="brand-subtitle">1200+ dan ziyot yo'l harakati qoidalari testlari to'plami</p>
          
          <div class="stats-container">
            <div class="stat-item">
              <span class="stat-value">500+</span>
              <span class="stat-label">Foydalanuvchilar</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">1220+</span>
              <span class="stat-label">Testlar</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">24/7</span>
              <span class="stat-label">Qo'llab-quvvatlash</span>
            </div>
          </div>
        </div>
      </div>

      <!-- O'ng tomondagi login formasi -->
      <div class="login-card-wrapper">
        <a-card class="login-card custom-card">
          <div class="card-header">
            <h2>Xush kelibsiz</h2>
            <p class="welcome-text">Davom etish uchun tizimga kiring</p>
          </div>

          <a-alert
            v-if="error"
            :message="error"
            type="error"
            show-icon
            class="error-alert"
          />

          <a-form
            layout="vertical"
            :model="form"
            @finish="onFinish"
            class="login-form"
          >
            <a-form-item
              label="Telefon raqam"
              name="phone"
              :rules="[
                { required: true, message: 'Telefon raqamingizni kiriting' },
                { validator: validatePhone, message: 'Noto\'g\'ri format' }
              ]"
            >
              <div class="phone-input-wrapper">
                <a-input 
                  v-model:value="displayPhone"
                  placeholder="+998-xx-xxx-xx-xx"
                  size="large"
                  class="premium-input"
                  @input="formatPhoneInput"
                >
                  <template #prefix>
                    <PhoneOutlined class="input-icon" />
                  </template>
                </a-input>
                <span v-if="detectedOperator" class="operator-tag">
                  {{ detectedOperator }}
                </span>
              </div>
              <small class="input-hint">Misol: +998-90-123-45-67</small>
            </a-form-item>

            <a-form-item
              label="Parol"
              name="password"
              :rules="[{ required: true, message: 'Parolingizni kiriting' }]"
            >
              <a-input-password 
                v-model:value="form.password" 
                placeholder="••••••••"
                size="large"
                class="premium-input"
              >
                <template #prefix>
                  <LockOutlined class="input-icon" />
                </template>
              </a-input-password>
            </a-form-item>

            <div class="form-options">
              <div></div>
              <a-button 
                type="link" 
                class="forgot-link"
                @click="handleForgotPassword"
              >
                <MessageOutlined /> Parolni unutdingizmi?
              </a-button>
            </div>

            <a-button
              type="primary"
              html-type="submit"
              block
              size="large"
              :loading="loading"
              class="login-button"
            >
              <template #icon><LoginOutlined /></template>
              Tizimga kirish
            </a-button>
          </a-form>

          <div class="divider">
            <span>yoki</span>
          </div>

          <!-- Telegram orqali ro'yxatdan o'tish -->
          <div class="telegram-section">
            <a-button 
              class="telegram-button"
              block
              size="large"
              @click="handleTelegramRegister"
            >
              <template #icon>
                <img src="https://telegram.org/img/t_logo.svg" alt="Telegram" class="telegram-icon" />
              </template>
              Telegram orqali ro'yxatdan o'tish
            </a-button>
            
            <p class="register-prompt">
              Akkountingiz yo'qmi? 
              <a href="#" class="register-link" @click.prevent="handleTelegramRegister">
                Ro'yxatdan o'tish
              </a>
            </p>
          </div>
        </a-card>
      </div>
    </div>

    <!-- Telegram modal -->
    <a-modal
      v-model:visible="telegramModalVisible"
      :footer="null"
      class="telegram-modal"
      width="min(90%, 400px)"
      :closable="false"
    >
      <div class="telegram-modal-content">
        <button class="modal-close" @click="telegramModalVisible = false">×</button>
        
        <div class="telegram-bot-info">
          <div class="bot-avatar-wrapper">
            <img src="https://telegram.org/img/t_logo.svg" alt="Telegram Bot" class="bot-avatar" />
          </div>
          <div class="bot-details">
            <h3>@YpxSmartTest</h3>
            <p>{{ telegramModalMessage }}</p>
          </div>
        </div>

        <div class="qr-container">
          <div class="qr-code">
            <img :src="`https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=https://t.me/YpxSmartTest?start=${telegramAction}`" alt="QR Code" />
          </div>
        </div>

        <div class="telegram-instructions">
          <div class="instruction-step">
            <span class="step-number">1</span>
            <span>Telegram'ni oching</span>
          </div>
          <div class="instruction-step">
            <span class="step-number">2</span>
            <span>@YpxSmartTest qidiring</span>
          </div>
          <div class="instruction-step">
            <span class="step-number">3</span>
            <span>"Start" tugmasini bosing</span>
          </div>
        </div>

        <a-button 
          type="primary" 
          block 
          size="large"
          :href="`https://t.me/SmartTestBot?start=${telegramAction}`"
          target="_blank"
          class="open-telegram-btn"
        >
          <img src="https://telegram.org/img/t_logo.svg" alt="Telegram" class="btn-icon" />
          Telegram'ni ochish
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { 
  PhoneOutlined, 
  LockOutlined, 
  LoginOutlined,
  MessageOutlined
} from '@ant-design/icons-vue'

export default {
  components: {
    PhoneOutlined,
    LockOutlined,
    LoginOutlined,
    MessageOutlined
  },
  data() {
    return {
      form: {
        phone: "",
        password: "",
      },
      displayPhone: "",
      error: "",
      loading: false,
      telegramModalVisible: false,
      telegramAction: 'register',
      telegramModalMessage: 'Botga start bosib avtorizatsiyadan o\'ting'
    }
  },
  computed: {
    detectedOperator() {
      const cleanPhone = this.form.phone.replace(/\D/g, '')
      if (cleanPhone.length < 5) return ''
      
      const code = cleanPhone.substring(3, 5)
      const operators = {
        '90': 'Beeline', '91': 'Beeline',
        '93': 'Ucell', '94': 'Ucell',
        '95': 'Uzmobile',
        '97': 'MobiUz', '88': 'MobiUz',
        '98': 'Perfectum',
        '99': 'Uzmobile',
        '33': 'Humans'
      }
      return operators[code] || ''
    }
  },
  methods: {
    formatPhoneNumber(value) {
      if (!value) return ''
      const numbers = value.replace(/\D/g, '')
      let formatted = numbers
      if (!numbers.startsWith('998')) {
        formatted = '998' + numbers.replace(/^998/, '')
      }
      
      if (formatted.length >= 3) {
        let result = '+' + formatted.substring(0, 3)
        if (formatted.length > 3) {
          result += '-' + formatted.substring(3, 5)
        }
        if (formatted.length > 5) {
          result += '-' + formatted.substring(5, 8)
        }
        if (formatted.length > 8) {
          result += '-' + formatted.substring(8, 10)
        }
        if (formatted.length > 10) {
          result += '-' + formatted.substring(10, 12)
        }
        return result
      }
      return '+' + formatted
    },
    
    formatPhoneInput(event) {
      let value = event.target.value
      let cleaned = value.replace(/[^\d+]/g, '')
      if (cleaned.indexOf('+') > 0) {
        cleaned = '+' + cleaned.replace(/\+/g, '')
      }
      
      let numbers = cleaned.replace(/\D/g, '')
      if (numbers.length > 0 && !numbers.startsWith('998')) {
        numbers = '998' + numbers.replace(/^998/, '')
      }
      if (numbers.length > 12) {
        numbers = numbers.substring(0, 12)
      }
      
      this.displayPhone = this.formatPhoneNumber(numbers)
      this.form.phone = numbers ? '+' + numbers : ''
      
      this.$nextTick(() => {
        event.target.value = this.displayPhone
      })
    },
    
    validatePhone() {
      const cleanPhone = this.form.phone.replace(/\D/g, '')
      if (!cleanPhone || cleanPhone.length < 12) {
        return Promise.reject('Telefon raqam to\'liq emas')
      } else if (!cleanPhone.startsWith('998')) {
        return Promise.reject('Raqam +998 bilan boshlanishi kerak')
      } else {
        const code = cleanPhone.substring(3, 5)
        const validCodes = ['90', '91', '93', '94', '95', '97', '98', '99', '33', '88']
        if (!validCodes.includes(code)) {
          return Promise.reject('Noto\'g\'ri operator kodi')
        } else {
          return Promise.resolve()
        }
      }
    },
    
    async onFinish() {
      this.loading = true
      this.error = ""

      try {
        const loginData = {
          phone: this.form.phone,
          password: this.form.password
        }
        
        await this.$store.dispatch("auth/login", loginData)
        this.$message.success('Muvaffaqiyatli kirdingiz!')
        
        this.$router.push("/")
      } catch (e) {
        this.error = e?.detail || "Telefon yoki parol noto‘g‘ri"
        this.$message.error(this.error)
      } finally {
        this.loading = false
      }
    },
    
    handleTelegramRegister() {
      this.telegramAction = 'register'
      this.telegramModalMessage = 'Botga start bosib avtorizatsiyadan o\'ting'
      this.telegramModalVisible = true
    },
    
    handleForgotPassword() {
      this.telegramAction = 'reset'
      this.telegramModalMessage = 'Parolni tiklash uchun botga murojaat qiling'
      this.telegramModalVisible = true
    }
  }
}
</script>

<style scoped>
/* Zoom muammosini hal qilish uchun viewport birliklari */
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg);
  position: relative;
  padding: clamp(10px, 2vw, 20px);
}

.login-gradient-bg {
  position: fixed;
  inset: 0;
  background: 
    radial-gradient(circle at 0% 0%, rgba(59, 130, 246, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 100% 100%, rgba(29, 78, 216, 0.15) 0%, transparent 50%),
    var(--bg);
  pointer-events: none;
}

.login-container {
  display: flex;
  width: min(1200px, 90vw);
  min-height: min(680px, 80vh);
  position: relative;
  z-index: 2;
  border-radius: clamp(16px, 3vw, 32px);
  overflow: hidden;
  background: var(--bg-card);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
}

/* Chap panel */
.brand-panel {
  width: 40%;
  background: linear-gradient(165deg, var(--bg-card-2), var(--bg-card));
  padding: clamp(24px, 4vw, 48px) clamp(16px, 3vw, 32px);
  display: flex;
  flex-direction: column;
  position: relative;
  border-right: 1px solid var(--border);
}

.brand-panel::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 30% 40%, rgba(59, 130, 246, 0.1), transparent 70%);
  pointer-events: none;
}

.brand-content {
  flex: 1;
  position: relative;
  z-index: 2;
}

.brand-header {
  display: flex;
  align-items: center;
  gap: clamp(8px, 1.5vw, 12px);
  margin-bottom: clamp(24px, 4vh, 32px);
}

.logo-container {
  position: relative;
  width: clamp(40px, 5vw, 48px);
  height: clamp(40px, 5vw, 48px);
}

.logo-glow {
  position: absolute;
  inset: 0;
  background: var(--primary);
  filter: blur(clamp(8px, 2vw, 16px));
  opacity: 0.3;
  border-radius: clamp(8px, 1.5vw, 12px);
  animation: pulse 3s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(1.1); }
}

.logo-icon {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--primary), var(--primary-soft));
  border-radius: clamp(10px, 2vw, 14px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-icon svg {
  width: 60%;
  height: 60%;
}

.brand-title {
  font-size: clamp(20px, 3vw, 24px);
  font-weight: 700;
  color: var(--text);
  margin: 0;
  background: linear-gradient(135deg, #fff, var(--primary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-subtitle {
  font-size: clamp(14px, 1.8vw, 16px);
  color: var(--text-soft);
  margin-bottom: clamp(32px, 6vh, 48px);
  line-height: 1.6;
}

.stats-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(12px, 2vw, 16px);
  margin-bottom: clamp(32px, 6vh, 48px);
  padding: clamp(16px, 3vh, 24px) 0;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}

.stat-item {
  text-align: center;
}

.stat-value {
  display: block;
  font-size: clamp(16px, 2.5vw, 20px);
  font-weight: 700;
  color: var(--primary);
  margin-bottom: clamp(2px, 0.5vh, 4px);
}

.stat-label {
  font-size: clamp(10px, 1.5vw, 12px);
  color: var(--text-soft);
}

.operators-section {
  margin-top: auto;
}

.operators-title {
  font-size: clamp(11px, 1.6vw, 13px);
  color: var(--text-soft);
  margin-bottom: clamp(8px, 1.5vh, 12px);
}

.operators-grid {
  display: flex;
  flex-wrap: wrap;
  gap: clamp(4px, 1vw, 8px);
}

.operator-badge {
  padding: clamp(2px, 0.8vw, 4px) clamp(8px, 1.5vw, 12px);
  background: var(--bg-card-2);
  border: 1px solid var(--border);
  border-radius: 20px;
  font-size: clamp(9px, 1.4vw, 11px);
  color: var(--text-soft);
  transition: all 0.3s;
}

.operator-badge:hover {
  border-color: var(--primary);
  color: var(--primary);
}

.brand-footer {
  margin-top: clamp(16px, 4vh, 32px);
  font-size: clamp(9px, 1.4vw, 11px);
  color: var(--text-soft);
  text-align: center;
}

/* O'ng panel */
.login-card-wrapper {
  width: 60%;
  padding: clamp(24px, 5vw, 48px);
  display: flex;
  align-items: center;
}

.login-card {
  width: 100%;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.card-header {
  margin-bottom: clamp(24px, 4vh, 32px);
}

.card-header h2 {
  font-size: clamp(24px, 3.5vw, 28px);
  font-weight: 700;
  color: var(--text);
  margin: 0 0 clamp(4px, 1vh, 8px) 0;
}

.welcome-text {
  color: var(--text-soft);
  font-size: clamp(13px, 1.8vw, 15px);
  margin: 0;
}

.error-alert {
  margin-bottom: clamp(16px, 3vh, 24px);
  border-radius: clamp(8px, 1.5vw, 12px);
  background: rgba(239, 68, 68, 0.1) !important;
  border: 1px solid rgba(239, 68, 68, 0.2) !important;
}

.error-alert :deep(.ant-alert-message) {
  color: var(--danger) !important;
  font-size: clamp(12px, 1.6vw, 14px);
}

.login-form {
  margin-bottom: clamp(16px, 3vh, 24px);
}

.phone-input-wrapper {
  position: relative;
}

.premium-input {
  background: var(--bg-card-2) !important;
  border: 1px solid var(--border) !important;
  color: var(--text) !important;
  border-radius: clamp(10px, 2vw, 14px) !important;
  height: clamp(40px, 6vh, 48px) !important;
  transition: all 0.3s;
}

.premium-input :deep(.ant-input) {
  background: transparent !important;
  color: var(--text) !important;
  font-size: clamp(13px, 1.8vw, 14px);
}

.premium-input :deep(.ant-input-prefix) {
  margin-right: clamp(8px, 1.5vw, 12px);
}

.input-icon {
  color: var(--text-soft) !important;
  font-size: clamp(14px, 2vw, 16px);
}

.operator-tag {
  position: absolute;
  right: clamp(8px, 2vw, 12px);
  top: 50%;
  transform: translateY(-50%);
  padding: clamp(2px, 0.8vw, 2px) clamp(6px, 1.5vw, 10px);
  background: var(--primary);
  color: white;
  border-radius: 20px;
  font-size: clamp(9px, 1.4vw, 11px);
  font-weight: 600;
  pointer-events: none;
  z-index: 2;
}

.input-hint {
  display: block;
  margin-top: clamp(4px, 1vh, 6px);
  color: var(--text-soft);
  font-size: clamp(9px, 1.4vw, 11px);
}

.form-options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: clamp(16px, 3vh, 24px);
}

.forgot-link {
  color: var(--primary) !important;
  padding: 0;
  font-size: clamp(11px, 1.6vw, 13px);
  display: flex;
  align-items: center;
  gap: clamp(4px, 1vw, 6px);
}

.forgot-link :deep(.anticon) {
  font-size: clamp(12px, 1.8vw, 14px);
}

.login-button {
  height: clamp(40px, 6vh, 48px);
  border-radius: clamp(10px, 2vw, 14px);
  background: linear-gradient(135deg, var(--primary), var(--primary-soft)) !important;
  border: none;
  font-weight: 600;
  font-size: clamp(13px, 1.8vw, 15px);
  transition: all 0.3s;
}

.login-button :deep(.ant-btn-icon) {
  margin-right: clamp(4px, 1vw, 8px);
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: clamp(16px, 3vh, 24px) 0;
  color: var(--text-soft);
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid var(--border);
}

.divider span {
  padding: 0 clamp(8px, 2vw, 16px);
  font-size: clamp(11px, 1.6vw, 13px);
}

.telegram-section {
  text-align: center;
}

.telegram-button {
  height: clamp(40px, 6vh, 48px);
  border-radius: clamp(10px, 2vw, 14px);
  background: #0088cc !important;
  color: white !important;
  border: none;
  font-weight: 600;
  font-size: clamp(13px, 1.8vw, 15px);
  transition: all 0.3s;
  margin-bottom: clamp(12px, 2vh, 16px);
}

.telegram-icon {
  width: clamp(16px, 2.5vw, 20px);
  height: clamp(16px, 2.5vw, 20px);
  filter: brightness(0) invert(1);
}

.register-prompt {
  color: var(--text-soft);
  font-size: clamp(11px, 1.6vw, 13px);
}

.register-link {
  color: var(--primary);
  font-weight: 600;
  margin-left: 4px;
}

/* Telegram modal */
.telegram-modal :deep(.ant-modal-content) {
  background: var(--bg-card) !important;
  border: 1px solid var(--border) !important;
  border-radius: clamp(16px, 3vw, 24px) !important;
  box-shadow: var(--shadow) !important;
}

.telegram-modal :deep(.ant-modal-body) {
  padding: 0 !important;
}

.telegram-modal-content {
  position: relative;
  padding: clamp(24px, 5vw, 32px) clamp(16px, 4vw, 24px);
}

.modal-close {
  position: absolute;
  top: clamp(8px, 2vw, 16px);
  right: clamp(8px, 2vw, 16px);
  width: clamp(24px, 4vw, 32px);
  height: clamp(24px, 4vw, 32px);
  border-radius: 50%;
  border: 1px solid var(--border);
  background: var(--bg-card-2);
  color: var(--text-soft);
  font-size: clamp(14px, 2.5vw, 18px);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  z-index: 10;
}

.telegram-bot-info {
  display: flex;
  align-items: center;
  gap: clamp(12px, 3vw, 16px);
  margin-bottom: clamp(16px, 4vh, 24px);
  padding: clamp(16px, 3vw, 20px);
  background: var(--bg-card-2);
  border-radius: clamp(12px, 2.5vw, 20px);
  border: 1px solid var(--border);
}

.bot-avatar-wrapper {
  width: clamp(40px, 8vw, 56px);
  height: clamp(40px, 8vw, 56px);
  border-radius: 50%;
  background: linear-gradient(135deg, #0088cc, #00a2ed);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bot-avatar {
  width: 55%;
  height: 55%;
  filter: brightness(0) invert(1);
}

.bot-details h3 {
  font-size: clamp(14px, 2.2vw, 16px);
  font-weight: 600;
  color: var(--text);
  margin: 0 0 4px 0;
}

.bot-details p {
  font-size: clamp(11px, 1.8vw, 13px);
  color: var(--text-soft);
  margin: 0;
}

.qr-container {
  display: flex;
  justify-content: center;
  margin-bottom: clamp(16px, 4vh, 24px);
}

.qr-code {
  padding: clamp(8px, 2vw, 12px);
  background: white;
  border-radius: clamp(12px, 2.5vw, 20px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.qr-code img {
  display: block;
  width: min(160px, 40vw);
  height: min(160px, 40vw);
}

.telegram-instructions {
  margin-bottom: clamp(16px, 4vh, 24px);
  padding: clamp(12px, 2.5vw, 16px);
  background: var(--bg-card-2);
  border-radius: clamp(12px, 2.5vw, 16px);
  border: 1px solid var(--border);
}

.instruction-step {
  display: flex;
  align-items: center;
  gap: clamp(8px, 2vw, 12px);
  padding: clamp(6px, 1.5vh, 8px) 0;
}

.instruction-step:not(:last-child) {
  border-bottom: 1px solid var(--border);
}

.step-number {
  width: clamp(20px, 3.5vw, 24px);
  height: clamp(20px, 3.5vw, 24px);
  background: var(--primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: clamp(10px, 1.8vw, 12px);
  font-weight: 600;
  flex-shrink: 0;
}

.open-telegram-btn {
  height: clamp(40px, 6vh, 48px);
  border-radius: clamp(10px, 2vw, 14px);
  background: #0088cc !important;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(4px, 1vw, 8px);
  font-weight: 600;
  font-size: clamp(13px, 1.8vw, 15px);
}

.btn-icon {
  width: clamp(16px, 2.5vw, 20px);
  height: clamp(16px, 2.5vw, 20px);
  filter: brightness(0) invert(1);
}

/* Responsive */
@media (max-width: 968px) {
  .login-container {
    flex-direction: column;
    width: 95vw;
    min-height: auto;
  }
  
  .brand-panel {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid var(--border);
  }
  
  .login-card-wrapper {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .brand-panel {
    padding: 20px;
  }
  
  .login-card-wrapper {
    padding: 20px;
  }
  
  .stats-container {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .stat-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
  }
  
  .stat-value {
    margin-bottom: 0;
  }
  
  .operators-grid {
    justify-content: center;
  }
}
</style>